import type { ReactNode } from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { MetricSkeleton } from "@/components/shared/loading-skeleton";
import { cn } from "@/lib/utils";

interface ReportMetricCardProps {
  title: string;
  value: ReactNode;
  valueClassName?: string;
  isLoading?: boolean;
}

export function ReportMetricCard({
  title,
  value,
  valueClassName,
  isLoading,
}: ReportMetricCardProps) {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-right text-base">{title}</CardTitle>
      </CardHeader>
      <CardContent
        className={cn("text-right text-2xl font-semibold", valueClassName)}
      >
        {isLoading ? (
          <MetricSkeleton />
        ) : (
          value
        )}
      </CardContent>
    </Card>
  );
}
